import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { LoaderInterceptor } from './http-intreceptors/loader-interceptor';

import { AppComponent } from './app.component';
import { PreCheckoutComponent } from './pages/pre-checkout/pre-checkout.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SpinnerModule } from './shared/spinner/spinner.module';
import { CommonModule } from '@angular/common';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { CpfValidatorDirective } from './shared/validators/cpf-validator.directive';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { AppRoutingModule } from './app-routing.module';
import { DisplayService } from './app.component.service';
import { PreCheckoutLoginComponent } from './pages/pre-checkout-login/pre-checkout-login.component';
import { NoaccessComponent } from './pages/noaccess/noaccess.component';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { ModalComponent } from './shared/modal/modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PreCheckoutComponenteService } from './pages/pre-checkout/pre-checkout.componente.service';
import { PreCheckoutViagemComponent } from './pages/pre-checkout-viagem/pre-checkout-viagem.component';
import { PreCheckoutViagemSemRotaComponent } from './pages/pre-checkout-viagem/pre-checkout-viagem-sem-rota/pre-checkout-viagem-sem-rota.component';
import { PreCheckoutViagemComRotaComponent } from './pages/pre-checkout-viagem/pre-checkout-viagem-com-rota/pre-checkout-viagem-com-rota.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { PreCheckoutViagemSendMailComponent } from './pages/pre-checkout-viagem/pre-checkout-viagem-send-mail/pre-checkout-viagem-send-mail.component';
import { PreCheckoutLoginSmsComponent } from './pages/pre-checkout-login/pre-checkout-login-sms/pre-checkout-login-sms.component';
import { PreCheckoutLoginInfoComponent } from './pages/pre-checkout-login/pre-checkout-login-info/pre-checkout-login-info.component';
import { ErrorService } from './services/alert.service';
import { PreCheckoutVeiculoComponent } from './pages/pre-checkout-veiculo/pre-checkout-veiculo.component';
import { PreCheckoutVeiculoSinalComponent } from './pages/pre-checkout-veiculo/pre-checkout-veiculo-sinal/pre-checkout-veiculo-sinal.component';
import { PreCheckoutVeiculoSensorEngateComponent } from './pages/pre-checkout-veiculo/pre-checkout-veiculo-sensor-engate/pre-checkout-veiculo-sensor-engate.component';
import { PreCheckoutVeiculoSensorBauComponent } from './pages/pre-checkout-veiculo/pre-checkout-veiculo-sensor-bau/pre-checkout-veiculo-sensor-bau.component';
import { PreCheckoutVeiculoAlvoOrigemComponent } from './pages/pre-checkout-veiculo/pre-checkout-veiculo-alvo-origem/pre-checkout-veiculo-alvo-origem.component';
import { PreCheckoutVeiculoMacroInicioViagemComponent } from './pages/pre-checkout-veiculo/pre-checkout-veiculo-macro-inicio-viagem/pre-checkout-veiculo-macro-inicio-viagem.component';
import { PreCheckoutAprovadoComponent } from './pages/pre-checkout-aprovado/pre-checkout-aprovado.component';

import * as Sentry from "@sentry/angular";
import { TokenInterceptorService } from './http-intreceptors/token-interceptor';
import { PreCheckoutChecklistComponent } from './pages/pre-checkout-checklist/pre-checkout-checklist.component';


export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, "/assets/i18n/",".json");
}

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  declarations: [
    AppComponent,
    PreCheckoutComponent,
    CpfValidatorDirective,
    PreCheckoutLoginComponent,
    NoaccessComponent,
    NotfoundComponent,
    ModalComponent,
    PreCheckoutViagemComponent,
    PreCheckoutViagemSemRotaComponent,
    PreCheckoutViagemComRotaComponent,
    PreCheckoutViagemSendMailComponent,
    PreCheckoutLoginSmsComponent,
    PreCheckoutLoginInfoComponent,
    PreCheckoutVeiculoComponent,
    PreCheckoutVeiculoSinalComponent,
    PreCheckoutVeiculoSensorEngateComponent,
    PreCheckoutVeiculoSensorBauComponent,
    PreCheckoutVeiculoAlvoOrigemComponent,
    PreCheckoutVeiculoMacroInicioViagemComponent,
    PreCheckoutAprovadoComponent,
    PreCheckoutChecklistComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SpinnerModule,
    CommonModule,
    NgxMaskModule.forRoot(),
    FontAwesomeModule,
    AppRoutingModule,
    NgbModule,
    AutocompleteLibModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    ErrorService,
    DisplayService,
    PreCheckoutComponenteService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private library: FaIconLibrary) {
    library.addIconPacks(fas);
  }
}
